import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import StagewiseToolbarWrapper from './components/DevTools/StagewiseToolbarWrapper';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
    {process.env.NODE_ENV === 'development' && <StagewiseToolbarWrapper />}
  </React.StrictMode>
);